import useSWR from 'swr';

import { GET_FAV_STORES_PATH } from '@/constants/api';
import useAuthStatus from '@/modules/core/hooks/useAuthStatus';
import { useFetcherWithToken } from '@/modules/core/hooks/useFetcherWithToken';
import { useAppContext } from '@/modules/core/providers/appConfigProvider';
import { FavouritesResponse } from '@/modules/shop/models/favouriteStore';

export const useGetAllFavouriteStores = () => {
  const { API_URL } = useAppContext();
  const fetcher = useFetcherWithToken();
  const url = `${API_URL}${GET_FAV_STORES_PATH}`;
  const isAuthenticated = useAuthStatus();
  return useSWR<FavouritesResponse>(isAuthenticated ? url : null, fetcher);
};
